import api from "../Utils/axios";
import { filterParams } from "../Utils/helpers";

export const getReviewByBookingId = (id) => {
  return api.get(`/ride/get-review/${id}`);
};

export const getAdminRideReviews = (page, perPage, search_string, from, to) => {
  return api.get(`/ride/admin/reviews`, {
    params: filterParams({
      page,
      limit: perPage,
      keyword: search_string,
      "createdAt[from]": from,
      "createdAt[to]": to,
    }),
  });
};
